var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.617 0C0.727682 0 6.10352e-05 0.642857 6.10352e-05 1.42857V12.8571C6.10352e-05 13.6429 0.727682 14.2857 1.617 14.2857H4.85087V12.9286L12.9355 5.78571V4.28571L8.08474 0H1.617ZM7.27627 1.07143L11.7228 5H7.27627V1.07143ZM13.0164 7.85714C12.9355 7.85714 12.7739 7.92857 12.693 8L11.8845 8.71429L13.5823 10.2143L14.3908 9.5C14.5525 9.35714 14.5525 9.07143 14.3908 8.92857L13.3398 8C13.2589 7.92857 13.1781 7.85714 13.0164 7.85714ZM11.3995 9.14286L6.4678 13.5V15H8.16559L13.0972 10.6429L11.3995 9.14286Z",
    fill: "#9AACCF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.e2b842b6.svg";
export { ForwardRef as ReactComponent };